import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    providers: [],
    providersMetadata: {},
    provider: {},
    providerMetadata: {}
  }
})
  .get({
    action: 'getProviders',
    property: 'providers',
    queryParams: true,
    path: '/providers/',
    onSuccess: payloadToState('providers')
  })
  .post({
    action: 'createProvider',
    property: 'provider',
    path: '/providers/',
    onSuccess: payloadToState('provider')
  })
  .get({
    action: 'getProvider',
    property: 'provider',
    path: ({ id }) => `/providers/${id}`,
    onSuccess: payloadToState('provider')
  })
  .put({
    action: 'updateProvider',
    property: 'provider',
    path: ({ id }) => `/providers/${id}`,
    onSuccess: payloadToState('provider')
  })
  .delete({
    action: 'deleteVodProvider',
    property: 'provider',
    path: ({ id }) => `/providers/${id}`,
    beforeRequest: getOptimisticDelete('providers'),
    onSuccess: payloadToState('provider')
  })
  .delete({
    action: 'deleteProvider',
    property: 'provider',
    path: ({ id }) => `/providers/${id}`,
    beforeRequest: getOptimisticDelete('providers'),
    onSuccess: payloadToState('provider')
  })
  .getStore()
